/* eslint-disable @typescript-eslint/no-explicit-any */
import deepmerge from 'deepmerge';
import CONSTANTS from '../constants/constants';
import getJsonnetData from '../utils/getJsonnetData';
import jsonnetConfigService from '../services/jsonnetConfigService';
const { APP_CONFIG_BASE_URL } = CONSTANTS;
const jsonnetApi = {
    getConfiguration: async ({ brand, region, country, language, }) => {
        try {
            const response = await (await getJsonnetData(APP_CONFIG_BASE_URL, brand, region, country, language)).json();
            if (!response) {
                throw new Error('Missing platform configuration response.');
            }
            const { checkout30, checkout40, configurator40, financeCalculator, myAccount, oauth, payment, platformFeatures, priceDisplay, salesEnablement, stockLocator, themeOverride, } = response;
            /*
            These variables checkout30, checkout40, and configurator40 are marked as optional
            since some markets may not have AdminBP or a complete configuration-management setup.
            Reading data from any of these keys in the public JSON could result in failure.
            */
            return {
                ...(configurator40 && { configurator40 }),
                myAccount,
                oauth,
                payment,
                platformFeatures,
                priceDisplay,
                salesEnablement,
                themeOverride,
                financeCalculator: jsonnetConfigService.transformFinanceCalculator(financeCalculator),
                //TODO: use checkout40 directly as checkout once all markets are using only  checkout40
                ...(checkout30 && checkout40
                    ? {
                        checkout: deepmerge(checkout30, checkout40, {
                            arrayMerge: (_, sourceArray) => sourceArray,
                        }),
                    }
                    : checkout30 || checkout40
                        ? { checkout: checkout30 || checkout40 }
                        : {}),
                dataLayer: !!platformFeatures.dataLayer,
                dxpDataLayer: !!platformFeatures.dxpDataLayer,
                additionalInfoGFV: platformFeatures?.additionalInfoGFV,
                useDxpFc: !!platformFeatures.useDxpFc,
                isDealerSelectionEnabled: !!platformFeatures.dealerSelectionIntegration,
                isVariantsPageEnabled: !!platformFeatures.variantsPage,
                isDivisionEnabled: platformFeatures.isDivisionEnabled,
                catalogTrimFeatures: platformFeatures.catalogTrimFeatures,
                clearInsuranceBlockInputInSalesEnablementNewDeal: platformFeatures.clearInsuranceBlockInputInSalesEnablementNewDeal,
                isExternalFinanceApplication: !!platformFeatures.isExternalFinanceApplication,
                isFinanceEnabled: !!platformFeatures.financeIntegration,
                configuratorFullSpecificationUrl: platformFeatures.spcFullSpecificationUrl,
                fetchBreakdownJsonSchema: !!financeCalculator?.fetchBreakdownJsonSchema,
                stockLocator: stockLocator,
            };
        }
        catch (e) {
            if (e instanceof Error) {
                throw new Error(e.message);
            }
            else {
                throw new Error('An unknown error occurred. Unable to get platform configuration.');
            }
        }
    },
};
export default jsonnetApi;
//# sourceMappingURL=jsonnetApi.js.map